import {Injectable} from '@angular/core';
import {StorageService} from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class PreferencesService {

  private mapPreferences = new Map();

  constructor(public localStorage: StorageService) {
  }

  LoadPreferences(aPrefsJsonObj: any, sender = '') {
    // this.mapPreferences.clear();
    // if (this.mapPreferences.size > 0) {
    //   return;
    // }
    const f1 = JSON.stringify(aPrefsJsonObj);
    const x1 = JSON.parse(f1);
    for (const key in x1) {
      if (Object.prototype.hasOwnProperty.call(x1, key)) {
        this.mapPreferences.set(key, x1[key]);
      }
    }
  }

  ListPreferences() {
    // console.log('---Preferences---');
    this.mapPreferences.forEach((value: string, key: string) => {
    });
  }

  // rlp
  GetByName(aName: string): boolean {
    return this.mapPreferences.get(aName);
  }

  GetDbNameFromPrefs(aName: string): string {
    return this.mapPreferences.get(aName);
  }

  // rlp

  LoadByLocalStorage(name: string) {
    const pref = this.localStorage.StorageGet('Preferences', '');
    if (!pref) {
      return '';
    }
    let matched = '';
    this.LoadPreferences(JSON.parse(pref));
    this.mapPreferences.forEach((value: string, key: string) => {
      if (key == name) {
        matched = value;
      }
    });
    return matched;
  }

  RestoreFromLocalStorage() {
    const pref = this.localStorage.StorageGet('Preferences', '');
    if (pref) {
      try {
        this.LoadPreferences(JSON.parse(pref));
      } catch (e) {
        console.error('Error parsing preferences from local storage', e);
      }
    }
  }
}
